export function scroll() {
  let isSyncingLeftScroll = false;
  let isSyncingRightScroll = false;
  let leftDiv = document.getElementById("leftDiv");
  let rightDiv = document.getElementById("scrollDiv");

  leftDiv.onscroll = function () {
    if (!isSyncingLeftScroll) {
      isSyncingRightScroll = true;
      rightDiv.scrollTop = this.scrollTop;
    }
    isSyncingLeftScroll = false;
  };

  rightDiv.onscroll = function () {
    if (!isSyncingRightScroll) {
      isSyncingLeftScroll = true;
      leftDiv.scrollTop = this.scrollTop;
    }
    isSyncingRightScroll = false;
  };
}
